import React from "react";

const ContactPage = () => (
  <div />
)

export default ContactPage;
